<template lang="pug">
  v-layout#wrapper(align-center justify-center row fill-height)
    v-card.mt-6.mt-md-0(style='max-width: 100%; width: 320px;')
      v-card-text.text-center
        template(v-if="!show2FA")
          v-avatar.mt-n12.mb-2.elevation-12.white(style='height: 102px; min-width: 102px; width: 102px;')
            v-icon(large style="font-size:102px" color="primary") fas fa-user-circle
          .title
            | Beechoo Origin
          FormWrapper.pt-2(type="auth")
            template( v-slot:default="props")
              AuthForm(
                :login-fn="login",
                :model="props.model",
                :valid="props.valid",
                :validate="props.validate",
              )
        template(v-else)
          v-card-text.text-center
            v-avatar.mt-n12.mb-2.elevation-0.white(
              style='height: 102px; min-width: 102px; width: 102px;'
            )
              v-icon.google-auth-icon
            .title
              | {{ QRCode ? 'Setup Google Authenticator' : 'Two-Factor Authentication' }}
            img(
              v-if="QRCode",
              :src="QRCode",
            )
            FormWrapper(
              type="twoFA",
              :form-class="QRCode ? ['pa-5', 'pt-0'] : []",
            )
              template( v-slot:default="props")
                GoogleAuthForm(
                  :login-fn="loginTwoFA",
                  :model="props.model",
                  :valid="props.valid",
                  :validate="props.validate",
                )

</template>

<script>
import AuthForm from "@/components/forms/Auth.vue";
import GoogleAuthForm from "@/components/forms/GoogleAuth.vue";
import FormWrapper from "@/components/wrapper/FormWrapper.vue";

export default {
  components: {
    AuthForm,
    GoogleAuthForm,
    FormWrapper,
  },

  data: () => ({
    show2FA: false,
    QRCode: null,
  }),

  methods: {
    loginTwoFA(payload) {
      this.$store.dispatch("auth/login2FA", payload).then(() => {
        this.$router.push({ name: "users" });
      });
    },

    login(payload) {
      this.$store.dispatch("auth/login", payload).then((res) => {
        this.show2FA = true;
        this.QRCode = res.data.QRCode;
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
#wrapper
  // background url(https://source.unsplash.com/P1qyEf1g0HU)
  height 100vh
  width 100vw
  background-size cover
  background-position center
  background-repeat no-repeat
  background-attachment fixed

.google-auth-icon
  background-image: url("/googleAuth.svg")
  background-size: contain
  background-repeat: no-repeat
  &::before {
    visibility: hidden;
    content: "";
  }
</style>
